import { render, staticRenderFns } from "./UserTypographyStylesResetModal.vue?vue&type=template&id=b97505f0&"
import script from "./UserTypographyStylesResetModal.vue?vue&type=script&lang=js&"
export * from "./UserTypographyStylesResetModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports